import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {CardButtonComponent} from '../card-button/card-button.component';
import {InteractionAnswerSaveDto, InteractionCardDto, ResultsDto, ResultsItemDto, StatisticsFormPhraseDto} from '../../models/card.model';
import {FormsModule} from '@angular/forms';
import {ConferenceService} from '../../service/conference.service';
import {WordCloudComponent} from '../word-cloud/word-cloud.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-card-form',
  templateUrl: './card-form.component.html',
  styleUrls: ['./card-form.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, CardButtonComponent, FormsModule, WordCloudComponent, TranslateModule],
})
export class CardFormComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<InteractionAnswerSaveDto>();

  @Input() set card(card: InteractionCardDto) {
    this._card = card;
    this.isSubmitted = (card.cardAnswer && card.cardAnswer.isCompleted);
    this.text = card.cardAnswer && card.cardAnswer.formAnswer ? card.cardAnswer.formAnswer.text : '';

    this.switchViews();
  }

  @Input() set isResults(isResults: boolean) {
    this._isResults = isResults;
    this.switchViews();
   }

  @Input() set isWordCloudReady(isWordCloudReady: boolean) {
    console.log('isWordCloudReady', isWordCloudReady);
    this._isWordCloudReady = isWordCloudReady;
    this.switchViews();
  }

  @Input() color: string = '#4f4f4f';
  @Input() color_inverse: string = 'white';

  _isWordCloudReady: boolean = false;

  isEnableSwitchViews: boolean = false;
  isSubmitted: boolean = false;

  _isResults: boolean | null = null;
  isShowingResults: boolean | null = null;

  _card: InteractionCardDto = {} as InteractionCardDto;
  phrases: StatisticsFormPhraseDto[] = [];
  text: string = '';

  constructor(
    private conferenceService: ConferenceService,
  ) {
  }

  ngOnInit() {
  }

  isValid() {
    return !!this.text;
  }

  submit(value: any) {
    if (!this.isValid()) {
      return;
    }

    this.isSubmitted = true;
    this.onSubmit.emit({
      interactionCardId: this._card.id,
      score: this._card.score,
      isCompleted: true,
      isPassed: true,
      groupExtId: 0,
      text: value,
      InteractionAnswerItems: [],
    } as InteractionAnswerSaveDto);
  }

  switchViews() {
    if (this._isResults === null) {
      return;
    }

    if (this._isResults && this._isWordCloudReady) {
      this.showResults();
    } else {
      this.hideResults();
    }
  }

  showResults() {
    this.conferenceService.getStatisticsForm(this._card.id, 0)
      .then((statistics) => {
        console.log('statistics', statistics);

        this.isShowingResults = false;
        this.phrases = statistics.phrases || [];
        if (this.phrases.length > 0) {
          setTimeout(() => {
            this.isShowingResults = true;
          });
        }
      });
  }

  hideResults() {
    this.isShowingResults = false;
  }
}
